import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "photo", "caption", "captionText", "counter", "previousButton", "nextButton"]
  static values = { photos: Array }

  connect() {
    this.currentIndex = 0
  }

  open(event) {
    event.preventDefault()
    this.currentIndex = event.params.index || 0
    this.updatePhoto()
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) this.close()
  }

  next(event) {
    event.preventDefault()
    this.currentIndex = (this.currentIndex + 1) % this.photosValue.length
    this.updatePhoto()
  }

  previous(event) {
    event.preventDefault()
    this.currentIndex = (this.currentIndex - 1 + this.photosValue.length) % this.photosValue.length
    this.updatePhoto()
  }

  handleKeydown(event) {
    if (this.modalTarget.classList.contains("hidden")) return

    if (event.key === "Escape") this.close()
    if (event.key === "ArrowLeft") this.previous(event)
    if (event.key === "ArrowRight") this.next(event)
  }

  updatePhoto() {
    const photo = this.photosValue[this.currentIndex]
    if (!photo) return

    this.photoTarget.src = photo.url
    this.photoTarget.alt = photo.alt
    this.counterTarget.textContent = `${this.currentIndex + 1} / ${this.photosValue.length}`

    if (photo.caption && photo.caption.trim() !== "") {
      this.captionTextTarget.textContent = photo.caption
      this.captionTarget.classList.remove("hidden")
    } else {
      this.captionTarget.classList.add("hidden")
    }

    const hasMultiplePhotos = this.photosValue.length > 1
    this.previousButtonTarget.classList.toggle("hidden", !hasMultiplePhotos)
    this.nextButtonTarget.classList.toggle("hidden", !hasMultiplePhotos)
  }
}
